import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './ui/SectionTag';
import { PlaceholderMockup } from './ui/PlaceholderMockup';
import type { TomoContent } from '../types/content';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
interface TomoItemProps {
  tomo: TomoContent;
  reverse: boolean;
}
export function TomoItem({
  tomo,
  reverse
}: TomoItemProps) {
  const isFeatured = Boolean(tomo.featuredBlock);
  return <div className={`flex flex-col gap-10 md:gap-14 ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center border-t border-mp-border pt-16 first:border-t-0 first:pt-0 md:pt-20`} data-id="element-378" data-mp="37d2zt8m36ydd">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.5,
      ease: easeOut
    }} className="w-full md:w-[44%]" data-id="element-379" data-mp="3bd3f0vh0fdlh">
        <PlaceholderMockup label={tomo.imageLabel} aspect="aspect-[4/5]" className={isFeatured ? 'border-mp-lime/40 shadow-glow-lime' : ''} src={tomo.imageUrl} alt={`${tomo.imageLabel} — atmósfera de pista de pádel`} width={800} height={1000} data-id="element-380" data-mp="qm2uue77qbzk" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.5,
      ease: easeOut,
      delay: 0.05
    }} className="w-full md:w-[56%]" data-id="element-381" data-mp="tf2vqp77dzt6">
        <SectionTag tone="lime" data-id="element-382" data-mp="qot1w566fba">{tomo.label}</SectionTag>
        <h3 className="mt-4 font-heading text-2xl uppercase tracking-wide text-mp-white sm:text-3xl" data-id="element-383" data-mp="5p8fryrl7v4p">
          {tomo.title}
        </h3>
        {tomo.subLabel && <p className="mt-1 font-heading text-xs uppercase tracking-[0.2em] text-mp-electric" data-id="element-384" data-mp="3968kcpma5nnp">{tomo.subLabel}</p>}

        <h4 className="mt-4 max-w-[560px] font-heading text-xl uppercase leading-snug text-mp-white sm:text-2xl" data-id="element-385" data-mp="3e4s9t0031hkt">
          {tomo.headline}
        </h4>

        <div className="mt-4 max-w-[600px] space-y-3 text-sm leading-relaxed text-mp-gray md:text-base" data-id="element-386" data-mp="362j7euajs4ki">
          {tomo.copy.map((p, idx) => <p key={idx} data-id="element-387" data-mp="3fuoxtzl5idxl" data-mpi={idx}>{p}</p>)}
        </div>

        <ul className="mt-6 grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-388" data-mp="3fw9sdp7gtwvg">
          {tomo.features.map(feature => <li key={feature} className="flex items-start gap-2 text-sm text-mp-gray" data-id="element-389" data-mp="2n5hxqw61tga8">
              <span className="mt-1.5 h-1 w-1 flex-shrink-0 rounded-full bg-mp-lime" data-id="element-390" data-mp="2j468wsv00z33" />
              {feature}
            </li>)}
        </ul>

        {tomo.featuredBlock && <div className="mt-7 rounded-2xl border border-mp-lime/40 bg-mp-lime/5 p-6" data-id="element-391" data-mp="2x1l1u7kgnozt">
            {tomo.featuredBlock.map((line, idx) => <p key={idx} className={`font-heading uppercase leading-tight sm:text-2xl md:text-3xl ${idx === tomo.featuredBlock!.length - 1 ? 'text-mp-lime' : 'text-mp-white'}`} data-id="element-392" data-mp="ccxawzlvgk69" data-mpi={idx}>
                {line}
              </p>)}
          </div>}

        {tomo.destacado && <p className="mt-7 max-w-[600px] rounded-xl border border-mp-border bg-mp-card px-5 py-4 text-sm leading-relaxed text-mp-white" data-id="element-393" data-mp="1gbtxiy3orw43">
            {tomo.destacado}
          </p>}
      </motion.div>
    </div>;
}